import { Layout } from 'components/common/layout/Layout';
import { GetStaticProps } from 'next';
import { CustomSEO } from '../components/common/layout/HeadMeta';
import { ProductReviews } from '../components/pricing/ProductReviews';
import { CollegeWScholar } from '../components/scholarships/CollegeWScholar';
import { DollarCurrent } from '../components/scholarships/DollarCurrent';
import { DollarCurrentDark } from '../components/scholarships/DollarCurrentDark';
import { Opportunities } from '../components/scholarships/Opportunities';
import { ScholarDescription } from '../components/scholarships/ScholarDescription';
import { ScholarColleges } from '../components/scholarships/ScholarshipColleges';
import { PageHeader } from '../components/sections/PageHeader';

export default function Scholarships() {
    const seoOverride: CustomSEO = {
        title: `Scholarships`,
        description: `Compare Stay Plugged In's subscription plans to gain more collegiate esports scholarship opportunities.`,
    };
    return (
        <Layout seoOverride={seoOverride}>
            <PageHeader
                title={'Scholarships'}
                description={''}
                className={'scholarship-page-header'}
                classNameTitle="big"
            />
            <ScholarDescription />
            <Opportunities />
            <CollegeWScholar />
            <DollarCurrentDark />
            <DollarCurrent />
            {/* <ScholarColleges label={''} description={''} /> */}
            {/* <CollegeSearchResultsDisplay searchColleges={searchColleges} /> */}
        </Layout>
    );
}

export const getStaticProps: GetStaticProps = async (ctx) => {
    return {
        props: {},
    };
};
